import { createFileRoute } from '@tanstack/react-router';
import { lerBuscaPessoas, PessoasPage } from '@/components/pessoas';

export const Route = createFileRoute('/_app/cadastros/pessoas')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaPessoas(bruto),
  component: PessoasRota,
});

function PessoasRota() {
  return <PessoasPage busca={Route.useSearch()} />;
}
